import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d7fbe5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Modelo", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemDeModelo = _resolveComponent("ItemDeModelo")!
  const _component_AdicionarModelo = _resolveComponent("AdicionarModelo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_TransitionGroup, { name: "modelos" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itensOrdenados, (modelo, indice) => {
          return (_openBlock(), _createBlock(_component_ItemDeModelo, {
            key: indice,
            modelo: (modelo as ModeloEditavel),
            ehPrimeiro: indice === 0,
            ehUltimo: indice === _ctx.itensOrdenados.length - 1,
            onEditar: _ctx.editar,
            onExcluir: _ctx.excluir,
            onDescer: _ctx.descer,
            onSubir: _ctx.subir
          }, null, 8, ["modelo", "ehPrimeiro", "ehUltimo", "onEditar", "onExcluir", "onDescer", "onSubir"]))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_AdicionarModelo, {
      indice: _ctx.itensOrdenados.length,
      onAdicionarItem: _ctx.adicionarItem
    }, null, 8, ["indice", "onAdicionarItem"])
  ], 64))
}